<template>
  <div class="flex xs12">
    <va-card :title="$t('forms.inputs.loadProducts') + ' ' + this.$route.params.loadCode">
      <va-button
        v-if="this.$route.params.assemblyLine == 10"
        medium
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-2"
        :to="{ name: 'loads_finished', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
          {{ $t('menu.back') }}
      </va-button>
      <va-button
        v-if="this.$route.params.assemblyLine == 9"
        small
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-0"
        :to="{ name: 'loads', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
        v-if="this.$route.params.assemblyLine == 11"
        small
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-0"
        :to="{ name: 'load_palletizing', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
      {{ $t('menu.back') }}
    </va-button>
      <va-button
        small
        inline
        color="green"
        icon="fa fa-download"
        class="ma-0"
        @click="exportLoadProductReport()"
      >
        {{ $t('menu.export') }}
      </va-button>
    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

      <va-data-table
        :fields="fields"
        :data="loadProducts"
        no-pagination
        v-show="!loading"
      />
    </va-card>
  </div>
</template>

<script>

import LoadProductAPI from '@/services/LoadProductAPI'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners,
  },
  data () {
    return {
      loadProducts: [],
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
      filepath: "",
    }
  },

  mounted () {
    this.getAllLoadProducts()
  },

  computed: {
    fields () {
      return [{
        name: 'product_integration_id',
        title: this.$t('forms.inputs.integrationId'),
      },
      {
        name: 'product',
        title: this.$t('tables.loadProducts.product_name'),
      },
      {
        name: 'quantity_boxes',
        title: this.$t('tables.loadProducts.quantity_boxes'),
        width: '3%',
      },
      {
        name: 'quantity_units',
        title: this.$t('tables.loadProducts.quantity_units'),
        width: '3%',
      },
      {
        name: 'product_family',
        title: this.$t('tables.loadProducts.product_family'),
      },
      {
        name: 'product_group',
        title: this.$t('tables.loadProducts.product_group'),
      },
      {
        name: 'fragility',
        title: this.$t('tables.loadProducts.fragility'),
        width: '10%',
      },
      {
        name: 'package',
        title: this.$t('tables.loadProducts.package'),
        width: '10%',
      },
      {
        name: 'units_per_box',
        title: this.$t('tables.loadProducts.unitsPerBox'),
        width: '3%',
      },
      {
        name: 'product_line',
        title: this.$t('tables.loadProducts.product_line'),
        width: '3%',
      },
      {
        name: 'ballast',
        title: this.$t('tables.loadProducts.ballast'),
        width: '3%',
      },
      {
        name: 'weight',
        title: this.$t('tables.loadProducts.weight'),
        width: '3%',
      },
      {
        name: 'length',
        title: this.$t('tables.loadProducts.length'),
        width: '3%',
      },
      {
        name: 'width',
        title: this.$t('tables.loadProducts.width'),
        width: '3%',
      },
      {
        name: 'height',
        title: this.$t('tables.loadProducts.height'),
        width: '3%',
      },
      {
        name: 'total_weight',
        title: this.$t('tables.loadProducts.total_weight'),
        width: '3%',
      },
      {
        name: 'cubage',
        title: this.$t('tables.loadProducts.cubage'),
        width: '3%',
      }]
    },

    spload () {
      return spinners.ScalingSquaresSpinner
    },
  },

  methods: {
    exportLoadProductReport(){
      LoadProductAPI.exportLoadProductReport(this.$route.params.loadID).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace("api/v1", "")
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        link.href = this.filepath
        link.download = response.data.filename
        document.body.appendChild(link)
        link.click()

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      });
    },

    getAllLoadProducts () {
      this.loading = true
      LoadProductAPI.getLoadProductsByLoadID(this.$route.params.loadID).then(response => {
        this.loadProducts = response.data.load_products
        this.loading = false
      })
    },
  },
}
</script>
